import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const DetalleBitacoraHallazgoService = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Bitacora/DetalleBitacoraHallazgo", values, customConfig);

        return resultado;

    } catch (error) {

        console.log(error);

    }

};

export { DetalleBitacoraHallazgoService };
